import React, { useContext } from 'react'
import { TranslateContext } from 'client/common/translator'
import { replaceTranslationPlaceholders, Text } from 'chemistry'
import classNames from 'classnames'
import { useSelector } from 'react-redux'

const Title = ({ title, isSoftContent }) => {
  const term = useSelector(state => state.data.term)
  const isCognitive = useSelector(state => state.data.products?.meta?.resultType === 'CES')

  const t = useContext(TranslateContext)
  const translationMapping = [['{term}', term]]

  if (!title && !term) return null
  return (
    <Text as='h1' color='black.300' className={classNames('mxd-lister-title', 'family-Rubrik')}>
      {term && (!isCognitive || isSoftContent) ? `${t('lister.search.title')} '${term}'` : title}
      {isCognitive &&
        !isSoftContent &&
        term &&
        replaceTranslationPlaceholders(translationMapping, t('lister.cognitive_search.title'))}
    </Text>
  )
}

export default Title
